import { render } from "./CambioPass.vue?vue&type=template&id=17a051cb&scoped=true"
import script from "./CambioPass.vue?vue&type=script&lang=js"
export * from "./CambioPass.vue?vue&type=script&lang=js"

import "./CambioPass.vue?vue&type=style&index=0&id=17a051cb&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a051cb"]])

export default __exports__